<template>
	<div>
		<el-container style="flex-direction: column;">
			<!-- <Header></Header> -->
			<NJNav></NJNav>
			<!-- <MachMonitor></MachMonitor> -->
			<div class="charts-box">
				<div class="tab-box">
					<div class="times">
						<p>农机补贴机具及作业面积统计</p>
						<p>统计时间：截止到{{ getNowFormatDates() }}</p>
						<!-- <p>{{ cityName }}补贴机具各省作业进度图<span>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</span></p> -->
					</div>
				</div>
				<div class="tab-boxs">
					<div class="tab_items" id="tab_items">
						<!-- <li v-for="(item,index) in tabArr" :class="[{'active':isActive == index},'items'+item.catThreeCode]" @click="tabClick(index, item)" :key="index"> -->
						<div v-for="(item, i) in njNumList1" :class="[{ 'active': activeNames == item.catThreeName },'nj_items'+item.icon, 'item_Num']" :key="i" @click="tabItemClick(item)">
							<div></div>
							<div class="nj_num_content">
								<p class="nj_name">{{ item.catThreeName }}
								<label class="countStyle">{{ item.njNum }}<span class="nj_danwei">台</span></label>
								</p>
								<p class="nj_num"><span class="nj_danwei">作业面积：</span>{{ item.workArea }}<span class="nj_danwei">{{item.workUnit}}亩次</span></p>
								<!--<p class="nj_num2">{{ item.workArea }}<span class="nj_danwei">{{item.workUnit}}亩次</span></p>-->

								<!--<p class="nj_danwei">农机数量（台）</p>-->
							</div>
							<!--<div>-->

							<!--<p class="nj_danwei">作业面积（亩次）</p>-->
							<!--</div>-->
						</div>
					</div>
					<div class="select-block" :style="sliderStyle">
						<div id="ToolChart" :style="sliderStyle"></div>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Api from "../../Serves/net-api.js";
	import Http from "../../Serves/net-http.js";
	// import MachMonitor from "./MachMonitor.vue";
	import NJNav from '../Index/view/NJNav'
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "ToolStatistics",
		components: {
			NJNav
			// MachMonitor
		},
		data() {
			return {
				Citychars: "",
				progressTitleClass: '',
				numsClass: '',
				itemList: [],
				njNumList1: [],
				njNumList2: [],
				activeNames: '全部智联机具',
				cityName: this.$store.state.info.govLevel === 1 ? '本市' : '',
				tabDataList: [],
				unit: '',
				sliderStyle: {
					width: '80%'
				}
			}
		},

		mounted() {
			// this.getdata() // 首次加载无数据图
			//			let wid = 100%-document.getElementById('tab_items').width()
			//			document.getElementById('select-block').CSS('width',wid)
			this.statisticsNjNumAndWorkAreaByArea()
			this.init()
			this.statisticMachine()

		},
updated(){
						console.log('leftWid',document.getElementById('tab_items').offsetWidth)
						let leftWid = document.getElementById('tab_items').offsetWidth>10?document.getElementById('tab_items').offsetWidth:260
						let wid = document.getElementsByClassName('tab-boxs')[0].offsetWidth - document.getElementById('tab_items').offsetWidth - 20;
						this.sliderStyle.width = wid + 'px'
						this.Citychars.resize()
},
		methods: {
//			unitFormat(value) {
//				const newValue = ['', '', '']
//				let fr = 1000
//				let num = 3
//				let text1 = ''
//				let fm = 1
//				while(value / fr >= 1) {
//					fr *= 10
//					num += 1
//					// console.log('数字', value / fr, 'num:', num)
//				}
//				if(num <= 4) { // 千
//					newValue[0] = value
//					newValue[1] = ''
//				} else if(num <= 8) { // 万
//					//					text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
//					text1 = '万'
//					fm = text1 === '万' ? 10000 : 10000000
//					if(value % fm === 0) {
//						newValue[0] = parseInt(value / fm) + ''
//					} else {
//						newValue[0] = parseFloat(value / fm).toFixed(2) + ''
//					}
//					newValue[1] = text1
//				} else if(num <= 16) { // 亿
//					text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
//					text1 = (num - 8) / 4 > 1 ? '万亿' : text1
//					text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
//					// tslint:disable-next-line:no-shadowed-variable
//					fm = 1
//					if(text1 === '亿') {
//						fm = 100000000
//					} else if(text1 === '千亿') {
//						fm = 100000000000
//					} else if(text1 === '万亿') {
//						fm = 1000000000000
//					} else if(text1 === '千万亿') {
//						fm = 1000000000000000
//					}
//					if(value % fm === 0) {
//						newValue[0] = parseInt(value / fm) + ''
//					} else {
//						newValue[0] = parseFloat(value / fm).toFixed(2) + ''
//					}
//					newValue[1] = text1
//				}
//				if(value < 1000) {
//					newValue[0] = value + ''
//					newValue[1] = ''
//				}
//				return newValue
//
//			},
			init() {
				setTimeout(() => {
					window.addEventListener("resize", () => {
						this.Citychars.resize()
					})
				}, 30)
			},
			tabItemClick(item) {
				this.activeNames = item.catThreeName
				// this.groupType = item.id
				this.statisticsNjNumAndWorkAreaByArea(item.catThreeCode)
			},
			statisticsNjNumAndWorkAreaByArea(typeId) {
				var parmse = {
					catThreeCode: typeId === '' ? '' : typeId
				}
				// var url = Http.test + '/screenBuyNj/statisticsNjNumAndWorkAreaBigData'
				var url = Http.test + '/homePageStatisByJSController/getCountNjNumByLocalByCatThreeCode'
				Api.doPost(url, parmse, false, res => {
					this.tabDataList = res.result
					this.getdata()

				})

			},
			statisticMachine() {
				let this_ = this;
				var url = Http.test + '/homePageStatisByJSController/getCountNjNumByLocal'
				Api.doPost(url, null, false, res => {
					let data = JSON.parse(JSON.stringify(res.result));
					data.forEach((item, index) => {
						item.workArea = this_.$common.unitFormat(item.workArea)[0];
						item.workUnit = this_.$common.unitFormat(res.result[index].workArea)[1];
					})
					this.njNumList1 = data
				})

			},
			getdata() {
				let data = this.tabDataList;
				var totalAreaArr = data.map(item => {
					return item.workArea
				})
				var nameArr = data.map(item => {
					return item.areaName
				})
				var totalArr = data.map(item => {
					return item.njNum
				})
				this.$nextTick(() => {
					
				
				this.Citychars = this.$echarts.init(document.getElementById('ToolChart'))
				this.Citychars.setOption({
					// backgroundColor: '#0B1640',
					// tooltip: {
					// 	trigger: 'axis',
					// 	axisPointer: {
					// 		type: 'cross',
					// 		label: {
					// 			backgroundColor: '#0B1640'
					// 		}
					// 	}
					// },
					tooltip: {
						trigger: "axis",
						formatter: function(params) {
							var relVal = '<div class="tooltipBox"><span">' + params[0].name + '</span>';
							for(var i = 0, l = params.length; i < l; i++) {
								let unit = params[i].seriesName == '作业面积' ? '亩' : '台'
								relVal += '<br/> <span>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit + '</span>'
							}
							relVal += '</div>'
							return relVal
						}
					},
					legend: {
						data: ['作业机具', '作业面积'],
						top: '0', // 距离容器上边界40像素
						left: '35%',
						textStyle: {
							color: '#ffffff',
							fontSize: 14
						}
					},
					grid: {
						top: '12%', // 距离容器上边界40像素
						bottom: '6%', // 距离容器下边界30像素
						left: 60,
						right: 80,
					},
					//					dataZoom: [
					//						//X轴滑动条
					//						{
					//							type: 'slider', //滑动条
					//							//							show: this.tabDataList.length > 15 ? true : false, //开启
					//							show: false,
					//							xAxisIndex: [0],
					//							left: '4%', //滑动条位置
					//							bottom: '2%',
					//							start: 0, //初始化时，滑动条宽度开始标度
					//							end: this.tabDataList.length > 15 ? 35 : 100 //初始化时，滑动条宽度结束标度
					//						},
					//						//X轴内置滑动
					//						{
					//							type: 'inside', //内置滑动，随鼠标滚轮展示
					//							xAxisIndex: [0],
					//							start: 1, //初始化时，滑动条宽度开始标度
					//							end: 100 //初始化时，滑动条宽度结束标度
					//						}
					//					],
					xAxis: [{
						type: 'category',
						axisLabel: {
							color: '#C8C7DD',
							fontSize: 16,
							// rotate: 45
							// fontWeight: 'bold'
						},
						axisLine: {
							lineStyle: {
								color: '#dddddd'
							},
							width: 5
						},
						axisTick: {
							show: false
						},
						data: nameArr
						// data: ['山东省', '湖南省', '上海市', '北京市', '天津市', '福建省', '湖北省', '河北省', '河南省']
					}],
					yAxis: [{
							type: 'value',
							name: '机具数量（台）',
							position: 'left',
							nameTextStyle: {
								color: '#C8C7DD'
							},
							axisLabel: {
								show: true,
								color: '#C8C7DD',
								formatter: '{value}'
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#dddddd'
								},
								width: 5
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false,
								lineStyle: {
									width: 0.2,
									type: 'dashed',
									color: '#e9e9e9'
								}
							}
						},
						{
							type: 'value',
							name: '作业面积（亩）',
							position: 'right',
							nameTextStyle: {
								color: '#C8C7DD'
							},
							axisLabel: {
								show: true,
								color: '#C8C7DD',
								formatter: '{value}'
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#dddddd'
								},
								width: 5
							},
							axisTick: {
								show: false
							},
							splitLine: {
								lineStyle: {
									// type: 'dashed',
									color: 'rgba(150, 164, 244, 0.3)'
								}
							}
						}
					],
					series: [{
							name: '作业机具',
							type: 'bar',
							barWidth: 24,
							color: "#4992FF",
							// xAxisIndex: 1,
							// yAxisIndex:1,
							// position:'left',
							data: totalArr
							// data: [2000.56, 33235, 45664, 4584, 8978, 1239, 45646, 4586, 74841]
						},
						{
							name: '作业面积',
							type: 'line',
							yAxisIndex: 1,
							color: '#88FFC3',
							data: totalAreaArr
							// data: [123, 456, 231, 321, 213, 421, 623, 95, 100]
						}
					]
				})
				})
			},
			timeFormat(date) {
				if(!date || typeof date === 'string') {
					this.error('参数异常，请检查...')
				}
				var y = date.getFullYear() // 年
				// this.yearValue = y
				var m = date.getMonth() + 1 // 月
				var d = date.getDate() // 日
				if(m >= 1 && m <= 9) {
					m = '0' + m
				}
				if(d >= 1 && d <= 9) {
					d = '0' + d
				}
				return y + '-' + m + '-' + d
			},
			// 获取本年第一个月
			getFirstDayOfYear(date) {
				date.setDate(1)
				date.setMonth(0)
				return this.timeFormat(date)
			},
			// 获取当前日期
			getNowFormatDates() {
				var date = new Date()
				// var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if(month >= 1 && month <= 9) {
					month = '0' + month
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				// var currentdate = year + seperator1 + month + seperator1 + strDate
				var currentdate = year + '年' + month + '月' + strDate + '日'
				return currentdate
			}
		}
	}
</script>
<style scoped>
	.countStyle{
		font-size: 22px;    font-weight: normal;
	}
	/*里面的代码可以根据自己需求去进行更改*/
	/* 设置滚动条的样式 */
	
	 ::-webkit-scrollbar {
		width: 3px;
	}
	/* 滚动槽 */
	
	 ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
		border-radius: 10px;
	}
	/* 滚动条滑块 */
	
	 ::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #0A63C6;
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
	}
	
	.toolStatistics {
		width: 100%;
		height: 72vh;
	}
	
	.charts-box {
		width: 98%;
		background-image: url('/static/img/zuoyejindu-bg.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;
		height: 83vh;
		/* height: 80vh; */
		margin-left: 1%;
		margin-top: 1vh;
	}
	/* @media screen and (max-width: 1540px) {
		.charts-box {
			height: 89vh;
		}
	}
	
	.select-block-pro {
		width: 100%;
		height: 70vh;
	} */
	
	.select-block {
		height: 75vh;
		float: left;
	}
	
	#ToolChart {
		width: 100%;
		height: 75vh;
	}
	
	.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
	.tab-boxs {
		width: 99%;
		margin-left: 1%;
		/*display: flex;*/
		/* background: #0B1640; */
		/* justify-content: space-between; */
	}
	
	.tablist_box {
		width: 100%;
	}
	
	.tablist_item {
		width: 100%;
		display: flex;
		margin-top: -14px;
		/* padding-left: 20px; */
	}
	
	.nums {
		width: 75%;
		display: flex;
		margin-top: 10px;
		color: #439BFF;
	}
	
	.item-nums {
		width: 15%;
	}
	/*.item-nums:nth-child(1){
  margin-right: 4vw;
  padding-left: 1vw;
}
.item-nums:nth-child(2){
  margin-right: 5vw;
}
.item-nums:nth-child(3){
  margin-right: 2.5vw;
}*/
	
	.item-nums span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-nums span:nth-child(1) {
		font-size: 1.3vw;
	}
	
	.item-numss {
		width: 9.7%;
		width: 15%;
	}
	
	.item-numss:nth-child(1) {
		margin-right: 4vw;
		padding-left: 1vw;
	}
	
	.item-numss:nth-child(2) {
		margin-right: 5vw;
	}
	
	.item-numss:nth-child(3) {
		margin-right: 2.5vw;
	}
	
	.item-numss span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-numss span:nth-child(1) {
		font-size: 1.3vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/TableList/ToolStatistics.vue